
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`C’est un travail d’une précision toute helvétique, qui a pris 20 ans. Ces dernières années, les cantons ont cartographié les risques naturels pesant sur le territoire suisse. Ces cartes de dangers permettent de voir quelles zones sont les plus exposées aux inondations, avalanches, chutes de pierres ou glissements de terrain.`}</p>
    <p>{`Presque toute la Suisse est désormais couverte par les cartes d’inondations et d’avalanches. Mais les cantons ne fournissent pas d’informations sur le nombre de personnes ou de bâtiments se trouvant dans des zones sensibles. Il est aussi impossible de visualiser ces dangers pour tout le pays, car les cantons ont publié leurs cartes séparément sur Internet.`}</p>
    <p>{`La cellule interactive de Tamedia a donc élaboré un outil qui vous permet de vérifier si votre adresse, ou n’importe quel endroit de Suisse, se trouve en zone de danger d’inondation ou d’avalanche.`}</p>
    <p>{`Il permet de voir que de larges régions de plaines sont exposées aux inondations, au point que 20% de la population peut-être concernée par ce risque, selon une estimation de la Confédération.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;